// TODO: This should be in @synegen/utility
import { Pipe, PipeTransform } from '@angular/core';

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;

/**
 * Formats a number of bytes into a human-readable string.
 *
 * @example
 * ```html
 * {{ 1024 | bytes }}           <!-- 1 KB -->
 * {{ 1536 | bytes : 2 }}       <!-- 1.50 KB -->
 * {{ 0 | bytes }}              <!-- 0 B -->
 * {{ null | bytes }}           <!-- — -->
 * ```
 */
@Pipe({
  name: 'bytes',
  standalone: true,
})
export class BytesPipe implements PipeTransform {
  transform(value: number | null | undefined, decimals = 1): string {
    if (value == null) return '—';
    if (value === 0) return '0 B';
    if (value < 0) return '—';

    const index = Math.min(Math.floor(Math.log(value) / Math.log(1024)), UNITS.length - 1);

    const result = value / Math.pow(1024, index);

    return `${result.toFixed(decimals).replace(/\.0+$/, '')} ${UNITS[index]}`;
  }
}
